// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {any} from 'codelyzer/util/function';

export const environment = {
  isContentLoading: false,
  loadingProviders: false,
  loadingAuthorizations: false,
  isDeployNeeded: false,
  selectedProvider: any,
  selectedIdProvider: '',
  typeSelectedProvider: '',
  renovation: any,
  activeIndex: 0,
  showSteps: false,
  usrGTM: true,
  usrHN: false,
  sendOtpNewDevice: false,
  production: false,
  policiesExclude: '',
  currentPolicy: '',
  policyHolderCardNumberOld: '',
  uniqueFormulary: false,
  
  authUrl: 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/auth',

  //urlApiMongo: 'https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementarydb-suzrx/graphql', // STG
  //urlApiJwt: 'https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementarydb-suzrx/auth/providers/api-key/login', // STG
  //keyJwt: 'IP0isJaBqOedEdCCIrDcTzgyC4AZ5nn2lqanxFYRsvV57HXQYQTiBdZd5JD02GRy', // STG
  //urlDocuments: 'https://ws-pre.mediprocesos.com/file-management/pdf-blob/RPN/',//STG
  urlDocuments: 'https://remote.mediprocesos.com/remote-server-web/PdfBlob',
  urlEnvironment: 'https://eia.mediprocesos.com',//PROD

  //urlDocuments: 'https://stg-elementary.mediprocesos.com:8080/remote-server-web/PdfBlob',//STG
  //urlEnvironment: 'https://stgeia.mediprocesos.com',

  //urlDocuments: 'https://remote.mediprocesos.com/remote-server-web/PdfBlob',
   //urlDocuments: 'https://stg-elementary.mediprocesos.com:8080/remote-server-web/PdfBlob',//STG
   //urlEnvironment: 'https://stgeia.mediprocesos.com',

  // CRENDENCIALES DENTAL OAUTH
  urlApiJwtDental: 'https://portalqa-auth.tecniseguros.com/connect/token', //STG
  clientSecretDental: 'c5b310d6-61ce-4625-b344-85193d7f1494', //STG
  scopeDental: 'apiIntegraciones', //STG
  clientIdDental: 'MediQa', //STG
  llaveTsDental: '7f815badeaba4443a0aac20ae4fad3b6', //STG
  // CREDENCIALES DENTAL OAUTH

  // CREDENCIALES CARNET TS OAUTH
  urlApiJwtTS: "https://portalqa-auth.tecniseguros.com/connect/token",
  GRANT_TYPE: "client_credentials",
  CLIENT_ID: "MediQa",
  CLIENT_SECRET: "c5b310d6-61ce-4625-b344-85193d7f1494",
  SCOPE: "apiIntegraciones",
  LLAVE_TS: "7f815badeaba4443a0aac20ae4fad3b6",
  urlApiCardTs: "https://tecnisegurosqa.azure-api.net/integraciones/info/carne",
  // CREDENCIALES CARNET TS OAUTH
 
  urlApiMongo: "https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementaryprod-nlumm/graphql", //PROD
  urlApiJwt: "https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementaryprod-nlumm/auth/providers/api-key/login", //PROD
  keyJwt: "AoeNBaHMbMv6Fx6KVaiep3Q9TTVc903Qkkbw7LGqhcyZOZRRsYZ9jElwlubDdJjn", //PROD
  //urlDocuments: 'https://ws-prod.mediprocesos.com/file-management/pdf-blob/RPN/',//PROD
  //urlEnvironment: 'https://eia.mediprocesos.com',//PROD

  urlApiMongoSettings: "https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/settings-bbotw/graphql", //PROD SETTINGS
  urlApiJwtSettings: "https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/settings-bbotw/auth/providers/api-key/login", //PROD SETTINGS
  keyJwtSettings: "PEEELL0sNOlh4zfXqYWznvYDIbx7sLw6ODM2mPnmLPsIanfDO45V3H6mNf2MvlgZ", //PROD SETTINGS
  
  config: {
    sync: {
      url: 'realms://provider-sync-cloud-staging.de1a.cloud.realm.io/StagingSync-Provider',
      error: err => console.log(err),
      // The behavior to use when this is the first time opening a realm.
     /*  newRealmFileBehavior: {
        type: "downloadBeforeOpen"
      }, */
      // The behavior to use when a realm file already exists locally,
      // i.e. you have previously opened the realm.
     /*  existingRealmFileBehavior: {
        type: "downloadBeforeOpen"
      }, */
      //fullSynchronization: true,
    },
// ...
  },
  firebase: {
    apiKey: 'AIzaSyBxfYl6JSeMdXgutGEI25ijPyi7SGrcuM0',
    authDomain: 'rpn-mediprocesos-002.firebaseapp.com',
    databaseURL: 'https://rpn-mediprocesos-002.firebaseio.com',
    projectId: 'rpn-mediprocesos-002',
    storageBucket: 'rpn-mediprocesos-002.appspot.com',
    messagingSenderId: '57254731680',
    appId: '1:57254731680:web:e15f556013a1e8e1',
    measurementId: 'G-SVF98FDVKN'
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
